var _style, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaerWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "maerWhite_svg__\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 693.7 114.6",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".maerWhite_svg__st0{fill-rule:evenodd;clip-rule:evenodd;fill:#fff}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "maerWhite_svg__st0",
    d: "M650.9 0h-67.3v114.6h29.8V87.5h32.4l12 27.1h32.7L675.4 80c33-22 19.1-80-24.5-80zm0 59.8h-37.5V28.2h37.5c18.6 0 19.4 31.6 0 31.6zM465.6 0v114.6h101.3V86.4h-71.3V70.5h58V44.1h-58V28.2h71.3V0zM151.3 0h59.3l20.2 65.2 20-65.2H310v114.6h-29.7V28.2h-7.7L246 114.6h-30.6l-26.6-86.4h-7.7v86.4h-29.8zM416.4 0h-56.6l-39.1 114.6h31.1l7.7-23.4h56.9l8 23.4h30.8L416.4 0zm-47.3 63l12-34.8h13.8l12 34.8h-37.8zM57.4 58l16.8-16.8h15.1l-7.1 23.7H33l-7.7-23.7h15.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "maerWhite_svg__st0",
    d: "M0 0v114.6h114.6V0H0zm57.2 16l7.2 6.9-7.2 7.2-6.9-7.2 6.9-6.9zm31.9 78.7H25.5v-9.9h63.6v9.9zm.2-19.9H25.8L11.7 31.1h33l12.7 12.8 12.8-12.8h32.7L89.3 74.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "maerWhite_svg__st0",
    d: "M89.3 41.2l-7.1 23.7H33l-7.7-23.7h15.1l17 16.8 16.8-16.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "maerWhite_svg__st0",
    d: "M89.3 41.2l-7.1 23.7H33l-7.7-23.7h15.1l17 16.8 16.8-16.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaerWhite);
export default __webpack_public_path__ + "static/media/maerWhite.4745dd5f5aadf6da930d09afae17e2bc.svg";
export { ForwardRef as ReactComponent };